import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Preview-only bypass elimination: replace legacy raw Checkfront/Droplet
 * widget routes for protected sister properties with a hard `location.replace`
 * to that property's official guarded booking page.
 *
 * Only a strict allowlist of date/intent query params is preserved. Host,
 * cfx, payment, and arbitrary tracking params are dropped for safety.
 */
const SAFE_PARAM_ALLOWLIST = new Set([
  "date",
  "start",
  "end",
  "dates",
  "checkin",
  "checkout",
  "start_date",
  "end_date",
  "arrival",
  "departure",
  "nights",
  "adults",
  "children",
  "guests",
]);

export function buildExternalBookingUrl(target: string, search: string): string {
  const url = new URL(target);
  const incoming = new URLSearchParams(search);
  incoming.forEach((value, key) => {
    if (SAFE_PARAM_ALLOWLIST.has(key.toLowerCase())) {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

export default function ExternalBookingRedirect({ target }: { target: string }) {
  const location = useLocation();

  useEffect(() => {
    const url = buildExternalBookingUrl(target, location.search);
    window.location.replace(url);
  }, [target, location.search]);

  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center" }}>
      <p>
        Redirecting to secure booking…{" "}
        <a href={buildExternalBookingUrl(target, location.search)}>Continue</a>
      </p>
    </div>
  );
}
